export default "__VITE_ASSET__BFECNtB9__"